import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/filters/status/dataGrid';
import { Event } from '@process-advisor/process-miner/api/events';

export type Row = {};

type Props = {
    setApplyEnabled: (value: boolean) => void;
    setDeleteDisabled: (value: boolean) => void;
    type: string
};


export const StatusGrid: React.FC<Props> = ({
    setApplyEnabled,
    setDeleteDisabled,
    type
}) => {
    const [data, setData] = React.useState<Row[]>([]);
    const [rows, setRows] = React.useState();

    const gridColumns = () => [
        {
            field: 'filter',
            headerName: type.charAt(0).toUpperCase() + type.slice(1),
            flex: 3,
        },
        {
            field: 'id',
            hide: true
        },

    ];
 
    React.useEffect(() => {
        if (data.length === 0) setDeleteDisabled(true)
        else setDeleteDisabled(false)
        setRows(data.map((row, id) => ({ id, ...row })))
    }, [data]);

    React.useEffect(() => {
        const listener = () => {
                setData(apiProvider.filterConditions({category: type}));
            }
        listener();

        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);
        apiProvider.on(Event.resetDiscovery, listener);
        apiProvider.on(Event.updateCurrentFilters, listener);

        return () => {
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
            apiProvider.off(Event.resetDiscovery, listener);
            apiProvider.off(Event.updateCurrentFilters, listener);
        };
    }, []);

    

    return (
        <DataGrid
            rows={rows}
            columns={gridColumns()}
            setDeleteDisabled={setDeleteDisabled}
            setApplyEnabled={setApplyEnabled}
            height="150px" />
    );
};
